var JoinDefaultServersMixins = require('joindefaultserversmixins');
var OrgEntity = require('orgentity');


var EnterpriseJoinView = Backbone.View.extend($.extend({}, JoinDefaultServersMixins, {
    el: '#enterpriseJoinContainer',
    initialize: function (options) {
        JoinDefaultServersMixins.initialize.call(this, options);
        this.joinExplanationJoined = this.$('.joinDefaultExplanationJoined');
        this.joinExplanationChannels = this.$('.joinDefaultExplanationChannels');
        this.joinExplanationServers = this.$('.joinDefaultExplanationServers');
    },
    joinDefaultServerAction: function (data, callback) {
        this.model.joinDefaultConnections(data, callback);
    },
    show: function (name) {
        if (this.isVisible()) {
            return;
        }

        this.showJoinInit(window.Enterprise.fullname);
        var prattle = this.model.get('autojoin_prattle');
        var org = new OrgEntity({
            name: window.Enterprise.fullname,
            admin: this.model.get('admin'),
            connections: this.model.get('autojoin_custom'),
            ircd: !!prattle,
            ircd_channels: prattle && prattle.join(' ')
        }, {
            session: this.model
        });
        this.showJoinOrg(org);

        this.showJoinPost(org);

        $(this.el).show();
        this.visible = true;
    },
    showJoinPost: function (org) {
        var nets = this.joinConnections;
        var noChans = nets.find('.chan').length === 0;
        this.joinExplanation.toggle(!org.haveJoined());
        if (noChans) {
            this.joinExplanationChannels.hide();
            this.joinExplanationServers.show();
        } else {
            this.joinExplanationServers.hide();
        }
        this.$('.enterpriseJoinedHeader').toggle(org.haveJoined());
        this.$('.enterpriseJoinHeader').toggle(!org.haveJoined());
        if (nets.find('a.chan, .matchConnChoiceExplanation').length || noChans) {
            this.joinExplanationJoined.show();
            this.$('.connections').hide();
            this.$('.join').hide();
            this.$('.passwords').hide();
            this.$('.both').hide();
            if (noChans) {
                this.$('.join').show();
            }
            if (nets.find('a.chan').length) {
                if (org.haveJoined()) {
                    this.$('.connections').show();
                } else {
                    this.$('.join').show();
                }
            }
            if (nets.find('.matchConnChoiceExplanation').length) {
                if (nets.find('.matchConnChoiceExplanation.password').length) {
                    this.$('.passwords').show();
                    if (nets.find('a.chan').length) {
                        this.$('button span.connections').hide();
                        this.$('button span.passwords').hide();
                        this.$('button span.both').show();
                    }
                } else {
                    this.$('.connections').show();
                }
            }
            if (nets.find('strong.chan').length) {
                this.joinAlready.show();
            }
        }
    },
    joinDefaultServerEndAction: function () {
        this.hide();
        if (!this.model.selectPreviousBuffer()) {
            this.model.trigger('currentBufferChange', this);
        }
    },
    hide: function () {
        if (!this.isVisible()) {
            return;
        }
        $(this.el).hide();
        this.hideJoinError();
        this.visible = false;
    },
    isVisible: function () {
        return !!this.visible;
    }
}));


module.exports = EnterpriseJoinView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/enterprisejoinview.js
// module id = aQSZ
// module chunks = 1